{
  "cp.components.appDrawer.drawerCourses": "الدورات التدريبية",
  "cp.components.appDrawer.drawerExport": "استخراج",
  "cp.components.appDrawer.drawerImprint": "الشروط",
  "cp.components.appDrawer.drawerInstitutes": "المعاهد",
  "cp.components.appDrawer.drawerSettings": "الاعدادات",
  "cp.components.appDrawer.drawerShares": "المشاركات",
  "cp.components.appDrawer.drawerSingleTrainings": "التدريبات",
  "cp.components.appDrawer.drawerTrainees": "المتدربين",
  "cp.components.appDrawer.drawerTrainers": "المدربين",
  "cp.components.changePassword.changePasswordButton": "تغيير كلمة المرور",
  "cp.components.changePassword.currentPassword": "كلمة المرور الحالية",
  "cp.components.changePassword.equalError": "كلمة المرور الجديدة هي نفس القديمة",
  "cp.components.changePassword.matchError": "كلمات المرور الجديدة غير متطابقة",
  "cp.components.changePassword.newPassword": "كلمة المرور الجديدة",
  "cp.components.changePassword.newPasswordRepeat": "كلمة مرور جديدة (تكرار)",
  "cp.components.changePassword.newRequiredError": "مطلوب كلمة مرور جديدة",
  "cp.components.changePassword.newToShortError": "كلمة المرور المقدمة قصيرة جدًا.",
  "cp.components.changePassword.requiredError": "كلمة المرور الحالية مطلوبة",
  "cp.components.changePassword.setPasswordButton": "تعيين كلمة المرور",
  "cp.components.changeUserRole.errorSnackbar": "حدث خطأ غير معروف. يرجى المحاولة مرة أخرى أو الاتصال بالدعم إذا استمر الخطأ.",
  "cp.components.changeUserRole.selectLabel": "اختر الدور",
  "cp.components.changeUserRole.successSnackbar": "تم تغيير الدور إلى{role}",
  "cp.components.courseTable.deleteLabel": "حذف",
  "cp.components.courseTable.downloadCSVTitle": "تنزيل ملف CSV",
  "cp.components.courseTable.downloadMessage": "تم اختيار الدورة التدريبية للتنزيل",
  "cp.components.courseTable.selected": "المحدد",
  "cp.components.courseTable.tableRowAssociatedTrainer": "المدرب المرتبط",
  "cp.components.courseTable.tableRowDate": "التاريخ",
  "cp.components.courseTable.tableRowIdentifier": "معرف الدورة التدريبية",
  "cp.components.courseTable.tableRowLocation": "الموقع",
  "cp.components.courseTable.tableRowProvider": "مزود التدريب",
  "cp.components.courseTable.tableRowTraineeCount": "عدد المتدربين",
  "cp.components.courseTable.tableRowValue": "القيمة",
  "cp.components.dialog.confirmDeletion.contentConclusion": "الحذف نهائي. لن يكون هذا الحساب متاحا بعد الآن.",
  "cp.components.dialog.confirmDeletion.contentDescription": "أنت على وشك حذف حساب له الدور (الأدوار) التالية:",
  "cp.components.dialog.confirmDeletion.title": "حذف الحساب المحدد؟",
  "cp.components.footer.rightsReserved": "كل الحقوق محفوظة.",
  "cp.components.general.institutePageSnackbarError": "خطأ في حفظ المعهد",
  "cp.components.general.institutePageSnackbarSuccess": "تم الحفظ",
  "cp.components.general.snackbar.emailAllreadySentSnackbar": "تم إرسال البريد الإلكتروني خلال الدقائق العشر الأخيرة. الرجاء الانتظار قبل أن تتمكن من إرسال واحدة أخرى.",
  "cp.components.general.tableRowName": "الاسم",
  "cp.components.genericTable.emptyMessage": "فارغ",
  "cp.components.genericTable.multiSelect": "تحديد الكل",
  "cp.components.genericTable.nextPage": "الصفحة التالية",
  "cp.components.genericTable.previousPage": "الصفحة السابقة",
  "cp.components.genericTable.rowsPerPageLabel": "عدد الصفوف في الصفحة:",
  "cp.components.genericTable.searchPlaceholder": "البحث",
  "cp.components.imprint.pageTitle": "شروط الاستخدام",
  "cp.components.instituteAdminTable.adminsTableEmail": "Email",
  "cp.components.instituteAdminTable.adminsTableInviteButton": "دعوة المشرف",
  "cp.components.instituteAdminTable.adminsTableSubtitle": "المستخدمون المسموح لهم بإدارة المعهد",
  "cp.components.instituteAdminTable.adminsTableTitle": "المسؤولون",
  "cp.components.instituteAdminTable.deleteAdminMessage": "هل تريد حقًا حذف المسؤول المحدد؟ سيكون هذا دائمًا.",
  "cp.components.instituteAdminTable.deleteLabel": "حذف",
  "cp.components.instituteAdminTable.deleteTrainerMessage": "هل تريد حقًا حذف المدرب المحدد؟ سيكون هذا دائمًا.",
  "cp.components.instituteAdminTable.name": "الاسم",
  "cp.components.instituteAdminTable.selected": "المحدد",
  "cp.components.instituteForm.institute": "المعهد",
  "cp.components.instituteForm.instituteAddress": "عنوان المعهد",
  "cp.components.instituteForm.instituteCity": "المدينة",
  "cp.components.instituteForm.instituteCountry": "الدولة",
  "cp.components.instituteForm.instituteName": "اسم المعهد",
  "cp.components.instituteForm.instituteSaveButton": "حفظ",
  "cp.components.instituteForm.instituteState": "الولاية",
  "cp.components.instituteForm.instituteStreet": "رقم الشارع والمنزل",
  "cp.components.instituteForm.instituteStreetAdditional": "إضافة إلى العنوان",
  "cp.components.instituteForm.instituteZIP": "الرمز البريدي",
  "cp.components.instituteForm.localeDanish": "الدانماركية",
  "cp.components.instituteForm.localeEnglish": "الإنجليزية",
  "cp.components.instituteForm.localeFinish": "الفنلندية",
  "cp.components.instituteForm.localeFrench": "الفرنسية",
  "cp.components.instituteForm.localeGerman": "الألمانية",
  "cp.components.instituteForm.localeItalian": "الايطالية",
  "cp.components.instituteForm.localeLabel": "اللغة",
  "cp.components.instituteForm.localeSpanish": "الاسبانية",
  "cp.components.instituteResultConfig.button": "تهيئة ملاحظات النتائج",
  "cp.components.instituteResultConfig.info": "يتم تطبيق هذه التغييرات على المعهد بأكمله. لكي يحدث هذا ، يجب على المدربين تسجيل الدخول إلى تطبيق CorPatch® Trainer مرة أخرى. ",
  "cp.components.instituteResultConfig.save": "حفظ الإعدادات",
  "cp.components.instituteResultConfig.thresholdGood": "حد جيد",
  "cp.components.instituteResultConfig.thresholdGreat": "حد عظيم",
  "cp.components.instituteTrainerTable.button": "دعوة المدرب",
  "cp.components.instituteTrainerTable.deleteLabel": "حذف",
  "cp.components.instituteTrainerTable.name": "Name",
  "cp.components.instituteTrainerTable.selected": "المحدد",
  "cp.components.instituteTrainerTable.subtitle": "جميع المدربين المنتمين للمعهد\n",
  "cp.components.instituteTrainerTable.tableRowsStreet": "الشارع",
  "cp.components.instituteTrainerTable.title": "المدربين",
  "cp.components.instituteTrainerTable.trainerEmptyMessage": "لا يوجد مدربين بعد",
  "cp.components.invite.inviteCancelButton": "إلغاء",
  "cp.components.invite.inviteEmailRequired": "البريد الإلكتروني",
  "cp.components.invite.inviteEmailSend": "تم الإرسال",
  "cp.components.invite.inviteEmailSent": "تم إرسال البريد الإلكتروني.",
  "cp.components.invite.inviteFirstnameLabel": "الاسم الأول",
  "cp.components.invite.inviteInvalidEmail": "هذا ليس عنوان بريد إلكتروني صالحًا",
  "cp.components.invite.inviteOk": "حسنا",
  "cp.components.invite.inviteSendButton": "إرسال دعوة",
  "cp.components.invite.inviteSubheader": "سيتم إرسال دعوة إلى عنوان البريد الإلكتروني هذا.",
  "cp.components.invite.inviteSurnameLabel": "اسم العائلة",
  "cp.components.navBar.menuLabel": "القائمة",
  "cp.components.passwordForgotSetPassword.changePasswordButton": "تغيير كلمة المرور",
  "cp.components.passwordForgotSetPassword.matchError": "كلمات المرور الجديدة غير متطابقة",
  "cp.components.passwordForgotSetPassword.newPassword": "كلمة المرور الجديدة",
  "cp.components.passwordForgotSetPassword.newPasswordRepeat": "كلمة مرور جديدة (تكرار)",
  "cp.components.passwordForgotSetPassword.newRequiredError": "مطلوب كلمة مرور جديدة",
  "cp.components.passwordForgotSetPassword.newToShortError": "كلمة المرور المقدمة قصيرة جدًا.",
  "cp.components.reminder.app.appAppStoreButton": "الانتقال إلى متجر تطبيقات Apple",
  "cp.components.reminder.app.appPlayStoreButton": "‏الانتقال إلى متجر Google Play",
  "cp.components.reminder.app.content": "لاستخدام CorPatch®، تحتاج إلى تطبيق CorPatch®. قم بتنزيله من متجر Google Playstore أو App Store. \n",
  "cp.components.reminder.app.title": "هل تريد أن تبدأ؟ قم بتنزيل التطبيق!",
  "cp.components.reminder.title": "CorPatch®",
  "cp.components.reminder.welcome": "مرحبا",
  "cp.components.resetPassword.changePasswordButton": "تغيير كلمة المرور",
  "cp.components.resetPassword.currentPassword": "كلمة المرور الحالية",
  "cp.components.resetPassword.equalError": "كلمة المرور الجديدة هي نفس القديمة",
  "cp.components.resetPassword.matchError": "كلمات المرور الجديدة غير متطابقة",
  "cp.components.resetPassword.newPassword": "كلمة المرور الجديدة",
  "cp.components.resetPassword.newPasswordRepeat": "كلمة مرور جديدة (تكرار)",
  "cp.components.resetPassword.newRequiredError": "مطلوب كلمة مرور جديدة",
  "cp.components.resetPassword.requiredError": "كلمة المرور الحالية مطلوبة",
  "cp.components.resetPassword.setPasswordButton": "تعيين كلمة المرور",
  "cp.components.singleTrainingsTable.shareDialogContent": "اختر المعهد الذي تريد مشاركة هذا التدريب معه:",
  "cp.components.singleTrainingsTable.shareDialogTitle": "مشاركة التدريب",
  "cp.components.singleTrainingsTable.shareDialogTooltip": "مشاركة التدريب",
  "cp.components.singleTrainingsTable.sharedDialogCancelButton": "إلغاء",
  "cp.components.singleTrainingsTable.sharedDialogShareButton": "مشاركة",
  "cp.components.singleTrainingsTable.sharedDialogTooltip": "تمت المشاركة في: ",
  "cp.components.singleTrainingsTable.tableRowDate": "التاريخ",
  "cp.components.singleTrainingsTable.tableRowDepth": "العمق",
  "cp.components.singleTrainingsTable.tableRowFlow": "التدفق",
  "cp.components.singleTrainingsTable.tableRowFrequency": "التردد",
  "cp.components.singleTrainingsTable.tableRowOrigin": "التدريب",
  "cp.components.singleTrainingsTable.tableRowRecoil": "ارتداد",
  "cp.components.singleTrainingsTable.tableShareTrainingTooltip": "مشاركة التدريب",
  "cp.components.userMenu.email": "البريد الإلكتروني",
  "cp.components.userMenu.logout": "تسجيل الخروج",
  "cp.components.userMenu.password": "كلمة المرور ",
  "cp.pages.acceptInvitation.button": "إلى صفحة تسجيل الدخول",
  "cp.pages.acceptInvitation.message": "كل شيء جاهز و على ما يرام!",
  "cp.pages.acceptInvitation.pageNotFound.message": "هذه الدعوة لم تعد صالحة بعد الآن.",
  "cp.pages.acceptInvitation.pageNotFound.title": "لم يتم العثور على الدعوة",
  "cp.pages.acceptInvitation.title": "تم.",
  "cp.pages.acceptInvitation.welcome": "مرحبا",
  "cp.pages.adminInvite.errorSnackbar": "البريد الإلكتروني {email} قيد الاستخدام بالفعل",
  "cp.pages.adminInvite.inviteCardTitle": "دعوة المسؤول",
  "cp.pages.adminInvite.successSnackbar": "إرسال البريد الإلكتروني إلى{email}",
  "cp.pages.admins.adminsEmpty.button": "دعوة المسؤول",
  "cp.pages.admins.adminsEmpty.message": "هل تريد دعوة المسؤول الأول للمعهد؟",
  "cp.pages.admins.adminsEmpty.selected": "المحدد",
  "cp.pages.admins.adminsEmpty.tableRowEmail": "البريد الإلكتروني",
  "cp.pages.admins.adminsEmpty.tableRowName": "الاسم",
  "cp.pages.admins.adminsEmpty.title": "لا يوجد مسؤولون حتى الآن!",
  "cp.pages.admins.adminsNotFound.message": "تم حذف هذا المعهد. ",
  "cp.pages.admins.adminsNotFound.title": "غير موجود!",
  "cp.pages.admins.instituteAdmin": "مشرف المعهد",
  "cp.pages.admins.tableRowInstitute": "المعهد",
  "cp.pages.admins.title": "المسؤولون",
  "cp.pages.course.cellDate": "التاريخ",
  "cp.pages.course.cellDuration": "المدة",
  "cp.pages.course.cellFeedback": "الملاحظات",
  "cp.pages.course.cellName": "الاسم",
  "cp.pages.course.rowDepth": "العمق",
  "cp.pages.course.rowFlow": "التدفق",
  "cp.pages.course.rowFrequency": "التردد",
  "cp.pages.course.rowRecoil": "ارتداد",
  "cp.pages.course.title": "الدورة التدريبية",
  "cp.pages.course.trainees": "المتدربون",
  "cp.pages.courses.errorSnackbar": "تعذر حذف هذه الدورة التدريبية.",
  "cp.pages.courses.pageNotFoundMessage": "تم حذفه. آسف :(",
  "cp.pages.courses.pageNotFoundTitle": "غير موجود",
  "cp.pages.courses.pageTitle": "الدورات التدريبية",
  "cp.pages.courses.roleInstituteAdmin": "مشرف المعهد",
  "cp.pages.courses.roleTrainee": "المتدرب",
  "cp.pages.courses.successSnackbar": "تم حذف الدورة التدريبية بنجاح.",
  "cp.pages.dashboard.cpsCount": "أجهزة CorPatch® النشطة",
  "cp.pages.dashboard.cpsCountRecently": "جهاز CorPatch® جديد متصل",
  "cp.pages.dashboard.lastMonth": "التطور خلال الشهر الماضي.",
  "cp.pages.dashboard.mobilesCount": "جميع الهواتف النقالة المعترف بها",
  "cp.pages.dashboard.mobilesCountRecently": "الهواتف المحمولة الأخيرة",
  "cp.pages.dashboard.pageTitle": "الإحصائيات",
  "cp.pages.dashboard.trainingsCount": "التدريبات المكتملة",
  "cp.pages.dashboard.usersCount": "إجمالي عدد المستخدمين المسجلين",
  "cp.pages.dashboard.usersCountRecently": "المستخدمين الجدد المسجلين",
  "cp.pages.email.validation.button": "الانتقال إلى تسجيل الدخول",
  "cp.pages.email.validation.text": "نشكرك على التحقق من عنوان بريدك الإلكتروني. سنستخدمه للحفاظ على أمان حسابك وإبقائك على اطلاع دائم إذا كنت ترغب في ذلك.",
  "cp.pages.export.pageTitle": "استخراج نتائج الدورة التدريبية",
  "cp.pages.homepage.title": "الصفحة الرئيسية",
  "cp.pages.institute.PageNotFound.message": "تم حذف هذا المعهد ولا يمكن تعديله بعد الآن.",
  "cp.pages.institute.PageNotFound.title": "لم يتم العثور على المعهد.",
  "cp.pages.institute.institute": "المعهد",
  "cp.pages.institute.snackbarError": "خطأ في حفظ المعهد",
  "cp.pages.institute.snackbarSuccess": "تم الحفظ",
  "cp.pages.institute.tabsAdmins": "المسؤولون",
  "cp.pages.institute.tabsBaseData": "البيانات الأساسية",
  "cp.pages.institute.tabsTrainers": "المدربين",
  "cp.pages.instituteAdminShares.active": "Active",
  "cp.pages.instituteAdminShares.deleted": "Deleted",
  "cp.pages.instituteAdminShares.endDate": "انتهاء: ",
  "cp.pages.instituteAdminShares.noActiveSharingObjectsMessage": "ليس لديك أي مواد مشاركة نشطة.",
  "cp.pages.instituteAdminShares.noDeletedSharingObjectsMessage": "لا توجد مواد مشاركة محذوفة.",
  "cp.pages.instituteAdminShares.pageNotFoundMessage": "المشاركات التي تبحث عنها غير موجودة.",
  "cp.pages.instituteAdminShares.pageTitle": "المشاركات",
  "cp.pages.instituteAdminShares.pageTitleNotFound": "غير موجود",
  "cp.pages.instituteAdminShares.startDate": "بداية: ",
  "cp.pages.institutes.addInstituteButton": "إضافة معهد",
  "cp.pages.institutes.deleteLabel": "حذف",
  "cp.pages.institutes.errorSnackbar": "تعذر حذف المعهد",
  "cp.pages.institutes.pageNotFound.message": "هل تريد إضافة أول معهد؟",
  "cp.pages.institutes.pageNotFound.title": "لم يتم العثور على أي معهد",
  "cp.pages.institutes.pageTitle": "المعاهد",
  "cp.pages.institutes.successSnackbar": "تم حذف المعهد بنجاح.",
  "cp.pages.institutesTable.deleteWarning": "هل تريد حذف المعهد المحدد؟ سيتم فقدان كافة الحسابات والبيانات المرتبطة!",
  "cp.pages.institutesTable.instituteLowercase": "المعهد",
  "cp.pages.institutesTable.institutesLowercase": "المعاهد",
  "cp.pages.institutesTable.tableRowCity": "المدينة",
  "cp.pages.institutesTable.tableRowCountry": "الدولة",
  "cp.pages.institutesTable.tableRowInstitutes": "المعاهد",
  "cp.pages.institutesTable.tableRowName": "الاسم",
  "cp.pages.institutesTable.tableRowStreet": "الشارع",
  "cp.pages.institutesTable.tableRowZIP": "الرمز البريدي",
  "cp.pages.internalServerError.button": "حاول مرة أخرى",
  "cp.pages.internalServerError.message": "لم يتمكن الخادم من إكمال الطلب. هذا على عاتقنا. يرجى المحاولة مرة أخرى لاحقًا.",
  "cp.pages.internalServerError.title": "الرجاء معاودة المحاولة في وقت لاحق.",
  "cp.pages.login.email": "البريد الإلكتروني",
  "cp.pages.login.loginButton": "تسجيل الدخول",
  "cp.pages.login.loginInstitutesTitle": "المعاهد",
  "cp.pages.login.password": "كلمة المرور ",
  "cp.pages.login.passwordForgot": "هل نسيت كلمة المرور؟",
  "cp.pages.login.registerButton": "تسجيل",
  "cp.pages.login.termsOfUseButton": "شروط الاستخدام",
  "cp.pages.login.userNewlyRegisteredLabel1": "لقد تم تسجيلك بنجاح.",
  "cp.pages.login.userNewlyRegisteredLabel2": "لا تنس تأكيد عنوان بريدك الإلكتروني وتسجيل الدخول على الفور.",
  "cp.pages.login.userOrPasswordNotFound": "لم يتم العثور على المستخدم أو كلمة المرور",
  "cp.pages.login.validate.errorContent": "ربما حاولت تسجيل الدخول من متصفح أو جهاز آخر أو قمت بإغلاق المتصفح الخاص بك في هذه الأثناء. حاول طلب بريد إلكتروني آخر لتسجيل الدخول.",
  "cp.pages.login.validate.errorSnackbar": "حدث خطأ أثناء تسجيل دخولك. قد يكون الرابط الخاص بك قديمًا.",
  "cp.pages.login.validate.errorTitle": "لم نتمكن من التعرف على جلسة المتصفح الخاص بك",
  "cp.pages.login.validate.successContent": "يرجى الانتظار لحظة بينما نقوم بالتحقق من صحة تسجيل الدخول الخاص بك.",
  "cp.pages.login.validate.successTitle": "نقوم بتسجيل دخولك",
  "cp.pages.login.validate.validationButton": "العودة إلى تسجيل الدخول",
  "cp.pages.login.validate.validationContent": "لقد أرسلنا لك بريدًا إلكترونيًا للتحقق من تسجيل دخولك.",
  "cp.pages.login.validate.validationTitle": "يرجى التحقق من تسجيل الدخول الخاص بك",
  "cp.pages.logout.loginButton": "تسجيل الدخول",
  "cp.pages.logout.message": "نراكم في المرة القادمة",
  "cp.pages.logout.title": "مع السلامة!",
  "cp.pages.me.deleteOwnButtonConfirm": "حذف حسابك نهائيا",
  "cp.pages.me.deleteOwnButtonRequest": "حذف حسابك نهائيا",
  "cp.pages.me.deleteOwnContent": "سيؤدي هذا الإجراء إلى حذف حسابك نهائيًا. يرجى التأكد من أنك قمت بحفظ أي بيانات قد تضيع عند حذف حسابك. يرجى العلم أنه لا يمكنك عكس هذا الإجراء.",
  "cp.pages.me.familyName": "اسم العائلة",
  "cp.pages.me.firstName": "الاسم الأول",
  "cp.pages.me.gender": "النوع",
  "cp.pages.me.genderFemale": "أنثى",
  "cp.pages.me.genderMale": "ذكر",
  "cp.pages.me.genderOther": "آخر",
  "cp.pages.me.notFoundTitle": "إعدادت الحساب",
  "cp.pages.me.save": "حفظ",
  "cp.pages.me.snackBarSaved.error": "حدث خطأ أثناء حفظ إعدادات الحساب ",
  "cp.pages.me.snackBarSaved.saved": "تم الحفظ",
  "cp.pages.me.title": "إعدادت الحساب",
  "cp.pages.networkError.pageNotFound.button": "حاول مرة أخرى",
  "cp.pages.networkError.pageNotFound.message": "لم يتمكن الخادم من إكمال الطلب. هل أنت متصل بالإنترنت؟",
  "cp.pages.networkError.pageNotFound.title": "يبدو أن الخادم معطل. هذا على عاتقنا! يرجى إعادة المحاولة لاحقًا. ",
  "cp.pages.notFound.message": "تعذر العثور على هذه الصفحة.",
  "cp.pages.notFound.title": "غير موجود.",
  "cp.pages.passwordForgot.confirmationMessage": "سيتم إرسال رسالة التحقق إلى حسابك.",
  "cp.pages.passwordForgot.confirmationMessage2": "يرجى التحقق من ذلك.",
  "cp.pages.passwordForgot.confirmationSendMessage": "لقد أرسلنا لك بريدًا إلكترونيًا يحتوي على رابط الموافقة على",
  "cp.pages.passwordForgot.confirmationSent": "إرسال بريد إلكتروني",
  "cp.pages.passwordForgot.confirmationTitle": "إعادة تعيين كلمة المرور",
  "cp.pages.passwordForgot.eMail": "البريد الإلكتروني",
  "cp.pages.passwordForgot.passwordForgotBackToLogin": "العودة إلى تسجيل الدخول",
  "cp.pages.passwordForgot.passwordForgotTitle": "نسيت كلمة المرور ",
  "cp.pages.passwordForgotSetPassword.button": "إلى صفحة تسجيل الدخول",
  "cp.pages.passwordForgotSetPassword.message": "كل شيء جاهز وعلى ما يرام!",
  "cp.pages.passwordForgotSetPassword.pageNotFound.message": "هذا الرمز لم يعد صالحا بعد الآن.",
  "cp.pages.passwordForgotSetPassword.pageNotFound.title": "غير صالح بعد الآن",
  "cp.pages.passwordForgotSetPassword.title": "تم تغيير كلمة المرور!",
  "cp.pages.passwordForgotSetPassword.welcome": "مرحبا",
  "cp.pages.register.acceptTermsOfUse": "هل تقبل شروط الاستخدام؟",
  "cp.pages.register.create": "إنشاء حساب",
  "cp.pages.register.emailField": "البريد الإلكتروني",
  "cp.pages.register.errorSnackbar": "حدث خطأ غير مقصود. يرجى المحاولة مرة أخرى.",
  "cp.pages.register.firstnameField": "الاسم الأول",
  "cp.pages.register.lastnameField": "اسم العائلة",
  "cp.pages.register.newToShortError": "كلمة المرور المقدمة قصيرة جدًا.",
  "cp.pages.register.passwordField": "كلمة المرور ",
  "cp.pages.register.successSnackbar": "لقد تم تسجيلك بنجاح.",
  "cp.pages.settings.feedbackMode.menuItemExpert": "شريط",
  "cp.pages.settings.feedbackMode.menuItemNone": "بدون اختيار",
  "cp.pages.settings.feedbackMode.menuItemSimple": "مضخة",
  "cp.pages.settings.menuItemThresholdGood": "ملاحظات الحد «جيدة»",
  "cp.pages.settings.menuItemThresholdGreat": "ملاحظات الحد «رائعة»",
  "cp.pages.settings.resultType.menuItemExpert": "خبير",
  "cp.pages.settings.resultType.menuItemNone": "بدون اختيار",
  "cp.pages.settings.resultType.menuItemSimple": "بسيط",
  "cp.pages.settings.resultType.menuItemStandard": "قياسي",
  "cp.pages.settings.tableRowCompression": "الضغطات فقط",
  "cp.pages.settings.tableRowDuration": "مدة الجلسة",
  "cp.pages.settings.tableRowERC": "تحقق من وجود علامات حيوية",
  "cp.pages.settings.tableRowFeedback": "وضع الملاحظات",
  "cp.pages.settings.tableRowFrequency": "التردد المستهدف",
  "cp.pages.settings.tableRowLocked": "مقفل",
  "cp.pages.settings.tableRowProperty": "الخاصية",
  "cp.pages.settings.tableRowResult": "نوع النتيجة",
  "cp.pages.settings.tableRowResultConfigSaveButton": "حفظ إعدادات النتيجة",
  "cp.pages.settings.tableRowSaveButton": "حفظ",
  "cp.pages.settings.tableRowTrainees": "العدد الافتراضي للمتدربين",
  "cp.pages.settings.tableRowType": "نوع الجلسة",
  "cp.pages.settings.tableRowValue": "القيمة",
  "cp.pages.settings.title": "إعدادات برنامج CorPatch® Trainer",
  "cp.pages.sharingObject.form.apiAccess": "الوصول إلى واجهة برمجة التطبيقات (API)",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage1": "هل أنت متأكد أنك تريد حذف مادة المشاركة؟",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage2": "لا يمكن التراجع عن هذا الإجراء ، ولكن لن يتم فقد أي بيانات. سيتم عرض عنصر المشاركة على أنه غير نشط.",
  "cp.pages.sharingObject.form.confirmDeleteDialogNo": "إلغاء",
  "cp.pages.sharingObject.form.confirmDeleteDialogTitle": "إزالة عنصر المشاركة",
  "cp.pages.sharingObject.form.confirmDeleteDialogYes": "حذف",
  "cp.pages.sharingObject.form.deleteButton": "حذف",
  "cp.pages.sharingObject.form.disabled": "معطل",
  "cp.pages.sharingObject.form.enabled": "ممكّن",
  "cp.pages.sharingObject.form.invitationCode": "رمز الدعوة",
  "cp.pages.sharingObject.form.invitationLink": "رابط الدعوة",
  "cp.pages.sharingObject.form.name": "الاسم",
  "cp.pages.sharingObject.form.pullApiSecret": "سر",
  "cp.pages.sharingObject.form.pullUrl": "سحب عنوان URL",
  "cp.pages.sharingObject.form.saveButton": "حفظ",
  "cp.pages.sharingObject.form.title": "عنصر المشاركة",
  "cp.pages.sharingObject.form.webHook": "WebHook",
  "cp.pages.sharingObject.pageNotFoundDescription": "عناصر المشاركة التي تبحث عنها غير موجودة.",
  "cp.pages.sharingObject.pageNotFoundTitle": "غير موجود",
  "cp.pages.sharingObject.pageTitle": "عناصر المشاركة",
  "cp.pages.sharingObject.snackBarDeleteError": "تعذر الحذف",
  "cp.pages.sharingObject.snackBarDeleted": "تم الحذف",
  "cp.pages.sharingObject.snackBarSaveError": "تعذر الحفظ",
  "cp.pages.sharingObject.snackBarSaved": "تم الحفظ",
  "cp.pages.singleTraining.multipleTrainings": "التدريبات",
  "cp.pages.singleTraining.singleTraining": "تدريب",
  "cp.pages.singleTraining.table.created": "تم الإنشاء",
  "cp.pages.singleTraining.table.name": "الاسم الكامل",
  "cp.pages.singleTraining.table.selected": "المحدد",
  "cp.pages.singleTraining.title": "التدريبات الخاصة بك",
  "cp.pages.trainee.cpsButton": "تنزيل بيانات CorPatch®",
  "cp.pages.trainee.delete.errorSnackbar": "حدث خطأ غير معروف",
  "cp.pages.trainee.delete.successSnackbar": "تم حذف المتدربين بنجاح",
  "cp.pages.trainee.delete.warningSnackbar": "لم يتم حذف مستخدم واحد أو أكثر",
  "cp.pages.trainee.deleteDialogButtonPrimary": "حذف",
  "cp.pages.trainee.deleteDialogButtonSecondary": "إغلاق",
  "cp.pages.trainee.deleteLabel": "حذف",
  "cp.pages.trainee.mobileButton": "تنزيل بيانات الهاتف الذكي",
  "cp.pages.trainee.multipleTrainees": "المتدربين",
  "cp.pages.trainee.singleTrainee": "المتدرب",
  "cp.pages.trainee.table.created": "تم الإنشاء",
  "cp.pages.trainee.table.email": "البريد الالكتروني",
  "cp.pages.trainee.table.name": "الاسم الكامل",
  "cp.pages.trainee.table.selected": "المحدد",
  "cp.pages.trainee.title": "المتدربون",
  "cp.pages.traineeShares.active": "نشط",
  "cp.pages.traineeShares.addDialogAdd": "إضافة",
  "cp.pages.traineeShares.addDialogCancel": "إلغاء",
  "cp.pages.traineeShares.addDialogDescription": "ادخل رمز الدعوة الذي حصلت عليه من المنظمة الشريكة لك:",
  "cp.pages.traineeShares.addDialogDescription2": "إذا اخترت النقر فوق «إضافة»، فأنت تقر بأنك توافق على الشروط والأحكام وسياسة الخصوصية المقدمة لك من قبل المنظمة الشريكة إلى جانب رابط/رمز الدعوة هذا. من الضروري قراءتها وفهمها قبل المتابعة.",
  "cp.pages.traineeShares.addDialogTitle": "دعوة",
  "cp.pages.traineeShares.addShare": "إضافة مشاركة",
  "cp.pages.traineeShares.deactivateDialogDescription": "هل أنت متأكد أنك تريد إلغاء تنشيط اتفاقية المشاركة هذه مع{instituteName} ؟",
  "cp.pages.traineeShares.deactivateDialogNo": "إلغاء",
  "cp.pages.traineeShares.deactivateDialogTitle": "إلغاء التنشيط",
  "cp.pages.traineeShares.deactivateDialogYes": "إلغاء التنشيط",
  "cp.pages.traineeShares.deactivateTooltip": "إلغاء التنشيط",
  "cp.pages.traineeShares.endDate": "تاريخ الانتهاء:",
  "cp.pages.traineeShares.inactive": "غير نشط",
  "cp.pages.traineeShares.noActiveItemsMessage": "حاليًا، لم توافق على أي اتفاقيات لمشاركة البيانات. اضغط على زر علامة الجمع في أسفل اليمين لإدخال رمز الدعوة المقابل.",
  "cp.pages.traineeShares.noInactiveItemsMessage": "لا توجد اتفاقيات مشاركة غير نشطة.",
  "cp.pages.traineeShares.pageNotFoundMessage": "مشاركات المتدرب التي تبحث عنها غير موجودة.",
  "cp.pages.traineeShares.pageTitle": "مشاركات المتدرب",
  "cp.pages.traineeShares.pageTitleNotFound": "غير موجود",
  "cp.pages.traineeShares.snackBarErrorAddingInvitation": "حدث خطأ أثناء إضافة الدعوة:{errorMessage} !",
  "cp.pages.traineeShares.snackBarErrorDeactivatingSharing": "حدث خطأ أثناء إلغاء تنشيط المشاركة:{errorMessage} !",
  "cp.pages.traineeShares.snackBarInvalidCode": "الرجاء إدخال رمز دعوة صالح.",
  "cp.pages.traineeShares.snackBarInvitationAdded": "تمت إضافة الدعوة",
  "cp.pages.traineeShares.snackBarSharingDeactivated": "تم تعطيل المشاركة",
  "cp.pages.traineeShares.startDate": "تاريخ البدء: ",
  "cp.pages.trainerInvite.errorSnackbar": "البريد الالكتروني قيد الاستخدام بالفعل",
  "cp.pages.trainerInvite.successSnackbar": "إرسال البريد الإلكتروني إلى{email}",
  "cp.pages.trainerInvite.title": "دعوة المدرب",
  "cp.pages.trainers.errorSnackbar": "تعذر حذف المستخدم. يرجى المحاولة مرة أخرى!",
  "cp.pages.trainers.successSnackbar": "تم الحذف.",
  "cp.pages.trainersNotAvailable.button": "دعوة المدرب",
  "cp.pages.trainersNotAvailable.message": "هل تريد دعوة أول مدرب؟",
  "cp.pages.trainersNotAvailable.title": "لا يوجد مدربين بعد!",
  "cp.pages.trainersNotFound.message": "لقد تم حذف هذا المدرب. آسف :(",
  "cp.pages.trainersNotFound.title": "لم يتم العثور على المدرب",
  "cp.pages.trainersTable.deleteLabel": "حذف",
  "cp.pages.trainersTable.inviteTrainer": "دعوة المدرب",
  "cp.pages.trainersTable.selected": "المحدد",
  "cp.pages.trainersTable.tableRowEmail": "البريد الالكتروني",
  "cp.pages.trainersTable.tableRowName": "الاسم",
  "cp.pages.trainersTable.trainers": "المدربين",
  "cp.pages.trainings.depth": "العمق",
  "cp.pages.trainings.flow": "التدفق",
  "cp.pages.trainings.frequency": "التردد",
  "cp.pages.trainings.notFound.message": "تم حذفه بالفعل. معذرة.",
  "cp.pages.trainings.notFound.title": "غير موجود",
  "cp.pages.trainings.recoil": "ارتداد",
  "cp.pages.trainings.title": "التدريبات",
  "cp.pages.trainings.trainee": "المتدرب",
  "cp.pages.trainings.trainingNumber": "رقم التدريب",
  "cp.pages.userChangeEmail.cancelButton": "إلغاء",
  "cp.pages.userChangeEmail.changeEmail": "تغيير البريد الإلكتروني",
  "cp.pages.userChangeEmail.email": "البريد الإلكتروني",
  "cp.pages.userChangeEmail.emailChangedSnackbar": "تم تغيير البريد الإلكتروني",
  "cp.pages.userChangeEmail.emailErrorSnackbar": "تعذر تغيير البريد الإلكتروني",
  "cp.pages.userChangeEmail.newEmail": "بريد إلكتروني جديد",
  "cp.pages.userChangeEmail.notFound.message": "هذا المستخدم لم يعد موجودا.",
  "cp.pages.userChangeEmail.notFound.title": "غير موجود.",
  "cp.pages.userChangeEmail.ok": "حسنا",
  "cp.pages.userChangeEmail.sendEmail": "تم إرسال البريد الإلكتروني",
  "cp.pages.userChangeEmail.verifyEmail.button": "أرسل لي رسالة تحقق جديدة عبر البريد الإلكتروني إلى عنواني",
  "cp.pages.userChangeEmail.verifyEmail.content": "نريد أن نبقيك على اطلاع بأحدث التغييرات التي تطرأ على تطبيقنا ومنتجاتنا. لذلك نحن بحاجة إلى التحقق من عنوان البريد الإلكتروني الخاص بك.",
  "cp.pages.userChangeEmail.verifyEmail.title": "يرجى التحقق من بريدك الإلكتروني",
  "cp.pages.userChangePassword.notChangedPasswordSnackbar": "تعذر تغيير كلمة المرور:",
  "cp.pages.userChangePassword.notFound.message": "تم حذف هذا المستخدم.",
  "cp.pages.userChangePassword.notFound.title": "لم يتم العثور على المستخدم. ",
  "cp.pages.userChangePassword.successSnackbar": "تم تغيير كلمة المرور",
  "cp.pages.userChangePassword.title": "تغيير كلمة المرور",
  "cp.pages.userChangePassword.wrongPasswordSnackbar": "كلمة المرور الحالية خاطئة",
  "cp.pages.userDetails.errorSnackbar": "تعذر إرسال الدعوة. ",
  "cp.pages.userDetails.invitation": "دعوة",
  "cp.pages.userDetails.notFound.message": "تم حذف هذه المعلومات. ",
  "cp.pages.userDetails.notFound.title": "غير موجود",
  "cp.pages.userDetails.sendInvitation": "إرسال دعوة",
  "cp.pages.userDetails.signUpAccepted": "تم القبول",
  "cp.pages.userDetails.signUpPending": "قيد الانتظار",
  "cp.pages.userDetails.successSnackbar": "تم إرسال الدعوة",
  "cp.pages.userDetails.userDetailsEmail": "البريد الالكتروني"
}